module.exports = __webpack_public_path__ + "img/20180815_150119_061.1991f1f5.jpg";